import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Navbar from "../components/Navbar";
import PurchaseTable from "../components/PurchaseTable";
import ExpensesTable from "../components/ExpensesTable";
import { pageAccessList } from "../helpers/pageAccessList";
import { api } from "../helpers/apiRequest";

function PurchaseExpenses() {
  const [userInfo] = useState(JSON.parse(localStorage.getItem('user')));
  const [accessControl, setAccessControl] = useState({});
  const fetchCurrentUser = async () => {
    try {
      let user = await localStorage.getItem('user');
      user = JSON.parse(user);

      if (user) {
        const res = await api.get(`/users/get/routes?userId=${userInfo?.id}`);
        const accessArray = res.data.message || [];
        // Map route permissions by route key
        const accessMapFromServer = accessArray.reduce((map, item) => {
          map[item.route] = item.allowed;
          return map;
        }, {});

        // Merge with full pageAccessList to ensure all routes are covered
        const accessMap = pageAccessList.reduce((acc, page) => {
          acc[page.key] = accessMapFromServer[page.key] || false;
          return acc;
        }, {});
        console.log("setAccessControl", accessControl);
        setAccessControl(accessMap);
      }
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchCurrentUser();
  }, []);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", padding: 2 }}>
      <Navbar title="Purchase & Expenses" />
      <Box
        marginTop={10}
        marginBottom={3}
        display="flex"
        flexDirection="column"
        gap={2}
      >
        <PurchaseTable accessControl={accessControl} />
        <ExpensesTable accessControl={accessControl}  />
      </Box>
    </Box>
  );
}

export default PurchaseExpenses;
